import GameHeader from "common/components/GameHeader/GameHeader";
import React, { useEffect } from "react";

import "./styles.scss";
import Button from "common/components/Button";
import { useTypedSelector } from "store";
import { useNavigate } from "react-router-dom";
import ThankYouAfterPaymentMobile from "./ThankYouAfterPaymentMobile";

const ThankYouAfterPayment = () => {
  const { successDataPayment } = useTypedSelector((store) => store.user);

  const navigate = useNavigate();
  useEffect(() => {
    if (!successDataPayment?.orderId) {
      alert(successDataPayment?.orderStatus);
      navigate("/main_page");
    }
  }, [navigate, successDataPayment]);
  return (
    <>
      <ThankYouAfterPaymentMobile successDataPayment={successDataPayment} />
      <div className="thank-you-wrapper">
        <GameHeader />
        <div className="thank-you-content-wrapper">
          <div className="thank-you-content-container">
            <h1>תודה שרכשתם מנוי לאתר GoBeB</h1>
            <div className="thank-you-content">
              <span>
                <strong>פרטי הזמנה:</strong>
              </span>
              <div style={{ marginTop: 65 }}>
                <div>
                  <span className="thank-you-regular-label">
                    שם לקוח: {successDataPayment?.customer}
                  </span>
                </div>
                <div>
                  <span className="thank-you-regular-label">
                    מספר הזמנה: {successDataPayment?.orderId}
                  </span>
                </div>
                <div>
                  <span className="thank-you-regular-label">
                    סוג מנוי: {successDataPayment?.product}
                  </span>
                </div>
                <div>
                  <span className="thank-you-regular-label">
                    סכום לתשלום: {successDataPayment?.sum}
                  </span>
                </div>
                <div>
                  <span className="thank-you-regular-label">
                    מספר תשלומים: {successDataPayment?.payments}
                  </span>
                </div>
                <div style={{ marginTop: 20 }}>
                  <span className="thank-you-regular-label">
                    אם נתקלתם בבעיה, יש{" "}
                    <strong className="thank-you-link" onClick={() => navigate("/contact")}>
                      לצור קשר
                    </strong>{" "}
                    ונשמח לסייע
                  </span>
                </div>
                <div style={{ marginTop: 20 }}>
                  <strong className="thank-you-regular-label-bold">
                    הרפתקה נפלאה מחכה לכם - צאו לדרך
                  </strong>
                </div>
                <div style={{ marginTop: 60 }}>
                  <span>צוות GoBeB</span>
                </div>
              </div>
              <div className="thank-you-container-btn">
                <Button text="התחילו לתרגל" onClick={() => navigate("/main_page")} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThankYouAfterPayment;
